import React from 'react';
import { Field, FormErrors, InjectedFormProps, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import { validateEmail } from 'mf-shared/utils/emailValidator';

import ResetPasswordField from '../Fields/ResetPasswordField/ResetPasswordField';

import styles from './style.css';

const validate = (values: FormField) => {
  const errors: FormErrors<FormField> = {};

  if (!values.email) {
    errors.email = 'The email address is required';
  } else if (!validateEmail(values.email)) {
    errors.email = 'The value is not a valid email address';
  }

  return errors;
};

const mapFormValidation = {
  form: 'ResetPasswordFormInvalid',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

const formConnector = reduxForm<FormField, ResetPasswordFormInvalidProps>(
  mapFormValidation
);

interface FormField {
  email: string;
}

interface ResetPasswordFormInvalidProps {
  readonly btnText: string;
}

type Props = ResetPasswordFormInvalidProps &
  InjectedFormProps<FormField, ResetPasswordFormInvalidProps>;

function ResetPasswordFormInvalid({ btnText, handleSubmit }: Props) {
  return (
    <div className="col-md-12 no-padding">
      <form onSubmit={handleSubmit}>
        <p className={`text-center ${styles['description-reset-password']}`}>
          The link provided is already expired or no longer match, please
          resubmit your email and try again.
        </p>

        <Field
          component={ResetPasswordField}
          name="email"
          maxLength="255"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder={'Registered email address'}
          spellCheck="false"
        />

        <div className={styles['submit-btn-container']}>
          <button
            type="submit"
            className={`btn btn-primary ${styles['submit-btn']}`}
          >
            {btnText}
          </button>
        </div>
      </form>
      <div
        className={`col-md-12 col-xs-12 text-center ${styles['back-to-login']}`}
      >
        <Link to="/login" className="text-center">
          Back to login
        </Link>
      </div>
    </div>
  );
}

export default formConnector(ResetPasswordFormInvalid);
